"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepper = exports.range = exports.message = exports.line = exports.label = exports.inputDisabled = exports.input = exports.button = void 0;

var _stylitas = require("@creditas/stylitas");

const button = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.form(theme)};
  width: 48px;
  height: 48px;
  color: ${_stylitas.utilities.palette.color(theme, 'secondary04')};
  background: transparent;
  border: 0;
  padding: 0;
  outline: none;
  overflow: hidden;
  cursor: pointer;
`;

exports.button = button;

const input = ({
  theme,
  color
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.paragraph(theme)};
  font-weight: 600;
  width: calc(100% - 96px);
  min-height: 100%;
  border: 0;
  padding: 0.5rem 0;
  outline: none;
  color: ${_stylitas.utilities.palette.color(theme, color)};
  border-bottom: 1px solid ${_stylitas.utilities.palette.color(theme, color)};
  text-align: center;
  background: transparent;
`;

exports.input = input;

const inputDisabled = ({
  theme,
  disabled
}) => disabled && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral05')};
    border-bottom-color: ${_stylitas.utilities.palette.color(theme, 'neutral05')};
  `;

exports.inputDisabled = inputDisabled;

const label = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.form(theme)};
  width: calc(100% - 32px);
  min-height: 32px;
  color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  display: block;
`;

exports.label = label;

const line = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.support(theme)};
  width: 100%;
  color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  display: block;
`;

exports.line = line;

const message = ({
  theme,
  color
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.support(theme)};
  color: ${_stylitas.utilities.palette.color(theme, color)};
  margin-top: 16px;
`;

exports.message = message;
const range = (0, _stylitas.css)`
  width: 50%;
  margin-top: 8px;
  text-align: left;

  &:nth-of-type(even) {
    text-align: right;
  }
`;
exports.range = range;
const stepper = (0, _stylitas.css)`
  min-width: 100%;
  display: flex;
  flex-wrap: wrap;
`;
exports.stepper = stepper;